module.exports = {
  version: '1.0.0',
  baseUrl: 'http://base.com/',
  imgServerPath: 'https://pests-diseases.obs.cn-east-2.myhuaweicloud.com/'
}